import {
  Button,
  Card,
  Grid,
  InputLabel,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import Header from "./header";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import CustomTimePicker from "../../../Components/CustomTimePicker";
import { ObjectToFormdata } from "../../../Common/Utils/common_utils";
import { GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
import { Cancel, CloudUpload } from "@material-ui/icons";
import AddToListModal from "../../../Components/FormGenerator/addToListModal";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import DateComponent from "../../../Components/FormGenerator/datepicker_component";
import StepperService from "./StepperService";
import { mappedKeyJSON } from "./MappedKeyJSON";
import CircularIndeterminate from "../../../Components/Loader";
import ImageCrop from "../../../Components/image-crop";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomSelectMulti from "../../../Components/CustomSelectMulti";
import PhoneInput from "react-phone-input-2";

const useStyles = makeStyles((theme) => ({
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
  },
}));

var refArr: any = [
  { email: "", phone: "", name: "" },
  { email: "", phone: "", name: "" },
  { email: "", phone: "", name: "" },
];
function Questionnaire(props: any) {
  const regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");

  var quesArr: any = [];
  const data: any = {
    business_experience: "",
    up_to_date_with_business_issues: "",
    coaching_started_date: "",
    // workload_distribution_id: "",
    // complementary_service_id: "",
    coach_training_hr_id: "",
    coaching_hr_id: "",
    evaluate_and_measure_coaching_assignments: "",
    preferences: "",
    additional_information: "",
    criteria_for_good_relationship_with_service_provider: "",
    // references_name_and_cont_detail_id: "",
    // industry_sector_list_id: "",
    discipline_id: "",
    at_what_level_id: "",
    last_job_title: "",
    most_senior_role_held: "",
    role_experience: "",
    worked_in_public_sector: "",
    worked_in_private_sector: "",
    level_id: "",
    thumbnail_bio: "",
    reference_other: "",
    insurance_in_place: "",
    // allow_insurance: "",
    references: refArr,
    sector_experience_id: "",
    group_facilitation: "",
    other: "",
    other_forms_of_coaching: "",
    team_coaching: "",
    executive_coaching: "",
    consulting: "",
    training: "",
    // attachment: "",
    // industry_sector_coached_in: "",
  };

  const classes = useStyles();
  const global_data = useSelector((state: any) => state.stepperReducer);
  const global_data_common = useSelector((state: any) => state.commonReducer);
  const dispatch = useDispatch();

  const [quesData, setQuesData]: any = useState({});
  const [focusText, setFocusText] = useState("1");
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [dataArr, setDataArr]: any = useState([]);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showAddNewModalExist, setShowAddNewModalExist] = useState(false);
  const [addNewModalProps, setAddNewModalProps] = useState({});
  const [userData, setUserData] = useState(data);
  const [workloadDistributionArr, setWorkloadDistributionArr]: any = useState(
    []
  );
  const [complementaryServiceArr, setComplementaryServiceArr]: any = useState(
    []
  );
  const [
    complementaryServiceArr_attribute,
    setComplementaryServiceArr_attribute,
  ]: any = useState([]);
  const [coachTrainingHrArr, setCoachTrainingHrArr]: any = useState([]);
  const [coachHrArr, setCoachHrArr]: any = useState([]);
  const [
    referencesNameAndContDetailArr,
    setReferencesNameAndContDetailArr,
  ]: any = useState([]);
  const [industrySectorListArr, setIndustrySectorListArr]: any = useState([]);
  const [industrySectorList_attribute, setIndustrySectorList_attribute]: any =
    useState([]);
  const [disciplineArr, setDisciplineArr]: any = useState([]);
  const [disciplineArr_attribute, setDisciplineArr_attribute]: any = useState(
    []
  );
  const [atWhatLevelArr, setAtWhatLevelArr]: any = useState([]);
  const [atWhatLevelArr_attribute, setAtWhatLevelArr_attribute]: any = useState(
    []
  );
  const [levelArr, setLevelArr]: any = useState([]);
  const [levelArr_attribute, setLevelArr_attribute]: any = useState([]);
  const [sectorExperienceArr, setSectorExperienceArr]: any = useState([]);
  const [sectorExperienceArr_attribute, setSectorExperienceArr_attribute]: any =
    useState([]);
  const [loading, setLoading] = useState(false);
  const [passportArr, setPassportArr]: any = useState([]);
  const [imageBlob, setImageBlob]: any = useState(null);
  const [viewDataFlag, setViewDataFlag]: any = useState(false);
  const [viewDataArr, setViewDataArr]: any = useState([]);
  const [addNewFlag, setAddNewFlag] = useState(false);

     const globaluserData = useSelector((state : any) => state.commonReducer);
     const role = globaluserData?.role;

  const updateData = () => {
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.WorkloadDistribution],
      setWorkloadDistributionArr,
      workloadDistributionArr
    );
    // StepperService.setCompDataArr(global_data_common.partnerDropdowns[mappedKeyJSON.ComplementaryService], setComplementaryServiceArr, complementaryServiceArr)
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.CoachTrainingHr],
      setCoachTrainingHrArr,
      coachTrainingHrArr
    );
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[mappedKeyJSON.CoachingHr],
      setCoachHrArr,
      coachHrArr
    );
    StepperService.setCompDataArr(
      global_data_common.partnerDropdowns[
        mappedKeyJSON.ReferencesNameAndContDetail
      ],
      setReferencesNameAndContDetailArr,
      referencesNameAndContDetailArr
    );
    // StepperService.setCompDataArr(global_data_common.partnerDropdowns[mappedKeyJSON.Discipline], setDisciplineArr, disciplineArr)
    // StepperService.setCompDataArr(global_data_common.partnerDropdowns[mappedKeyJSON.AtWhatLevel], setAtWhatLevelArr, atWhatLevelArr)
    // StepperService.setCompDataArr(global_data_common.partnerDropdowns[mappedKeyJSON.Level], setLevelArr, levelArr)
    // StepperService.setCompDataArr(global_data_common.partnerDropdowns[mappedKeyJSON.IndustrySector], setIndustrySectorListArr, industrySectorListArr)
    // StepperService.setCompDataArr(global_data_common.partnerDropdowns[mappedKeyJSON.SectorExperience], setSectorExperienceArr, sectorExperienceArr)

    levelArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.Level],
      {
        id: global_data_common.partnerDropdowns[mappedKeyJSON.Level] + 1,
        value: "+ Add New",
      },
    ];
    setLevelArr(levelArr.concat(pdata));

    industrySectorListArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.IndustrySector],
      {
        id:
          global_data_common.partnerDropdowns[mappedKeyJSON.IndustrySector] + 1,
        value: "+ Add New",
      },
    ];
    setIndustrySectorListArr(industrySectorListArr.concat(pdata));

    complementaryServiceArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[
        mappedKeyJSON.ComplementaryService
      ],
      {
        id:
          global_data_common.partnerDropdowns[
            mappedKeyJSON.ComplementaryService
          ] + 1,
        value: "+ Add New",
      },
    ];
    setComplementaryServiceArr(complementaryServiceArr.concat(pdata));

    disciplineArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.Discipline],
      {
        id: global_data_common.partnerDropdowns[mappedKeyJSON.Discipline] + 1,
        value: "+ Add New",
      },
    ];
    setDisciplineArr(disciplineArr.concat(pdata));

    atWhatLevelArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.AtWhatLevel],
      {
        id: global_data_common.partnerDropdowns[mappedKeyJSON.AtWhatLevel] + 1,
        value: "+ Add New",
      },
    ];
    setAtWhatLevelArr(atWhatLevelArr.concat(pdata));

    sectorExperienceArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.SectorExperience],
      {
        id: global_data_common.partnerDropdowns[mappedKeyJSON.Suffix] + 1,
        value: "+ Add New",
      },
    ];
    setSectorExperienceArr(sectorExperienceArr.concat(pdata));
    // suffixArr.length = 0;
    //     var pdata = [...response[mappedKeyJSON.Suffix], { id: response[mappedKeyJSON.Suffix] + 1, value: "+ Add New" }];
    //     setSuffixArr(suffixArr.concat(pdata));

    if (global_data.questionnaire_id != null) {
      setLoading(true);
      AdminPartnerClient.Questionnaire_get(global_data.questionnaire_id, {
        partner_profile_id: global_data.partner_profile,
      })
        .then((response: any) => {
          console.log(response.data);
          console.log(
            `response.data.attributes.qa_and_ref_detail?.reference_detail`,
            response.data.attributes.qa_and_ref_detail?.reference_detail
          );
          var localRefArr: any = [];
          if (
            response.data.attributes.qa_and_ref_detail.reference_detail !=
            undefined
          ) {
            refArr.map((option: any, i: any) => {
              console.log(
                `response.data.attributes.qa_and_ref_detail.reference_detail[i]`,
                response.data.attributes.qa_and_ref_detail.reference_detail[i]
              );
              if (
                response.data.attributes.qa_and_ref_detail.reference_detail[
                  i
                ] == undefined
              ) {
                localRefArr.push(option);
              } else {
                localRefArr.push(
                  response.data.attributes.qa_and_ref_detail.reference_detail[i]
                );
              }
            });
          }
          setUserData({
            business_experience: response.data.attributes.business_experience,
            up_to_date_with_business_issues:
              response.data.attributes.up_to_date_with_business_issues,
            coaching_started_date:
              response.data.attributes.coaching_started_date,
            group_facilitation: response.data.attributes.group_facilitation,
            other: response.data.attributes.other,
            other_forms_of_coaching:
              response.data.attributes.other_forms_of_coaching,
            team_coaching: response.data.attributes.team_coaching,
            executive_coaching: response.data.attributes.executive_coaching,
            consulting: response.data.attributes.consulting,
            training: response.data.attributes.training,
            coaching_hr_id: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[mappedKeyJSON.CoachingHr],
              response.data.attributes.coaching_hr_id
            ),
            coach_training_hr_id: StepperService.getValueFromArrById(
              global_data_common.partnerDropdowns[
                mappedKeyJSON.CoachTrainingHr
              ],
              response.data.attributes.coach_training_hr_id
            ),
            evaluate_and_measure_coaching_assignments:
              response.data.attributes
                .evaluate_and_measure_coaching_assignments,
            preferences: response.data.attributes.preferences,
            additional_information:
              response.data.attributes.additional_information,
            criteria_for_good_relationship_with_service_provider:
              response.data.attributes
                .criteria_for_good_relationship_with_service_provider,
            last_job_title: response.data.attributes.last_job_title,
            most_senior_role_held:
              response.data.attributes.most_senior_role_held,
            role_experience: response.data.attributes.role_experience,
            worked_in_public_sector:
              response.data.attributes.worked_in_public_sector != null
                ? response.data.attributes.worked_in_public_sector
                  ? "true"
                  : "false"
                : "",
            worked_in_private_sector:
              response.data.attributes.worked_in_private_sector != null
                ? response.data.attributes.worked_in_private_sector
                  ? "true"
                  : "false"
                : "",
            insurance_photo:
              response.data.attributes.insurance_photo != null
                ? response.data.attributes.insurance_photo
                  ? "true"
                  : "false"
                : "",
            insurance_in_place:
              response.data.attributes.insurance_in_place != null
                ? response.data.attributes.insurance_in_place
                  ? "true"
                  : "false"
                : "",
            thumbnail_bio: response.data.attributes.thumbnail_bio,
            reference_other: response.data.attributes.reference_other,
            references: localRefArr,
          });
          passportArr.length = 0;
          if (response.data.attributes.insurance_photo.length > 0) {
            var localPassportArr: any = [];
            var pdata = {
              attributes: {
                created_at:
                  response.data.attributes.insurance_photo[0].created_at,
                file_name:
                  response.data.attributes.insurance_photo[0]
                    .insurance_file_name,
                url: response.data.attributes.insurance_photo[0].photo.url,
                id: response.data.attributes.insurance_photo[0].id,
              },
            };
            localPassportArr.push(pdata);
            console.log(localPassportArr);
            setPassportArr(passportArr.concat(localPassportArr));
          }

          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.industry_sector_list_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.IndustrySector],
            setIndustrySectorList_attribute,
            industrySectorList_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.level_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.Level],
            setLevelArr_attribute,
            levelArr_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.at_what_level_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.AtWhatLevel],
            setAtWhatLevelArr_attribute,
            atWhatLevelArr_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.discipline_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.Discipline],
            setDisciplineArr_attribute,
            disciplineArr_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.sector_experience_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.SectorExperience],
            setSectorExperienceArr_attribute,
            sectorExperienceArr_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.attributes.complementary_service_id,
            global_data_common.partnerDropdowns[
              mappedKeyJSON.ComplementaryService
            ],
            setComplementaryServiceArr_attribute,
            complementaryServiceArr_attribute
          );

          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    updateData();
  }, [addNewFlag]);
  const [valuedAdded, setValueAdded] = useState({ added: false, value: null });
  useEffect(() => {
    if (valuedAdded?.added) {
      setValueAdded({ added: false, value: null });
      updateData();
    }
  }, [global_data_common.partnerDropdowns, valuedAdded.added]);
  const firstElementRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
  }, []);
  const onSubmit = () => {
    var flag = true;

    if (flag) {
      setSubmitClickFlag(false);
      for (var i in quesData) {
        quesArr.push({ question_id: i, answer: quesData[i] });
      }

      var docpassArr: any = [],
        industrySectorListIdArr: any = [],
        levelArrLocal: any = [],
        complementaryServiceArrLocal: any = [],
        sectorExperienceArrLocal: any = [],
        disciplineArrLocal: any = [],
        atWhatLevelArrLocal: any = [];

      passportArr.map((option: any) => {
        option.attributes.document &&
          docpassArr.push(option.attributes.document);
      });
      industrySectorList_attribute.length > 0 &&
        industrySectorList_attribute.map(
          (option: any) => option && industrySectorListIdArr.push(option.id)
        );
      atWhatLevelArr_attribute.length > 0 &&
        atWhatLevelArr_attribute.map(
          (option: any) => option && atWhatLevelArrLocal.push(option.id)
        );
      disciplineArr_attribute.length > 0 &&
        disciplineArr_attribute.map(
          (option: any) => option && disciplineArrLocal.push(option.id)
        );
      complementaryServiceArr_attribute.length > 0 &&
        complementaryServiceArr_attribute.map(
          (option: any) =>
            option && complementaryServiceArrLocal.push(option.id)
        );
      sectorExperienceArr_attribute.length > 0 &&
        sectorExperienceArr_attribute.map(
          (option: any) => option && sectorExperienceArrLocal.push(option.id)
        );
      levelArr_attribute.length > 0 &&
        levelArr_attribute.map(
          (option: any) => option && levelArrLocal.push(option.id)
        );

      var postData = {
        ...userData,
        coach_training_hr_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.CoachTrainingHr],
          userData.coach_training_hr_id
        ),
        coaching_hr_id: StepperService.getSelectedIdFromArr(
          global_data_common.partnerDropdowns[mappedKeyJSON.CoachingHr],
          userData.coaching_hr_id
        ),
        discipline_id:
          disciplineArrLocal.length > 0
            ? JSON.stringify(disciplineArrLocal)
            : "[]",
        industry_sector_list_id:
          industrySectorListIdArr.length > 0
            ? JSON.stringify(industrySectorListIdArr)
            : "[]",
        complementary_service_id:
          complementaryServiceArrLocal.length > 0
            ? JSON.stringify(complementaryServiceArrLocal)
            : "[]",
        sector_experience_id:
          sectorExperienceArrLocal.length > 0
            ? JSON.stringify(sectorExperienceArrLocal)
            : "[]",
        at_what_level_id:
          atWhatLevelArrLocal.length > 0
            ? JSON.stringify(atWhatLevelArrLocal)
            : "[]",
        level_id:
          levelArrLocal.length > 0 ? JSON.stringify(levelArrLocal) : "[]",
        references: JSON.stringify(userData.references),
        insurance_photo: docpassArr[0],
        remove_insurance_photo: docpassArr[0] == undefined ? true : false,
      };

      setLoading(true);

      if (global_data.questionnaire_id == null) {
        AdminPartnerClient.Questionnaire(
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,
            ...postData,
          })
        )
          .then((response: any) => {
            dispatch({
              type: GLOBAL_STEPPER_DATA,
              payload: {
                questionnaire_id: response.data.id,
                referenceDetail:
                  response.data.attributes.qa_and_ref_detail.reference_detail,
              },
            });
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information saved successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        AdminPartnerClient.Questionnaire_put(
          global_data.questionnaire_id,
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,
            ...postData,
          })
        )
          .then((response: any) => {
            console.log(response);
            if (response.data) {
              dispatch({
                type: GLOBAL_STEPPER_DATA,
                payload: {
                  referenceDetail:
                    response.data.attributes.qa_and_ref_detail.reference_detail,
                },
              });
              props.parentHandleNext(props.activeIndex + 1);
              dispatch(
                showSnackbar("Success", ["Information updated successfully"])
              );
            }
            if (response.message) {
              dispatch(showSnackbar("error", ["" + response.message]));
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    } else {
      setSubmitClickFlag(true);
    }
  };

  const setRefInputState = (
    inputStateValue: any,
    inputId: any,
    dataIndex: any
  ) => {
    console.log(userData.references);
    setUserData({
      ...userData,
      references: userData.references.map((option: any, i: any) => {
        if (i == dataIndex) {
          option[inputId] = inputStateValue;
          option[inputId] != ""
            ? setSubmitClickFlag(false)
            : setSubmitClickFlag(true);
        }
        return option;
      }),
    });
    console.log(userData.references);
  };
  const setRefInputStateOnChange = (
    inputStateValue: any,
    inputId: any,
    dataIndex: any
  ) => {
    console.log(userData.references);
    setUserData({
      ...userData,
      references: userData.references.map((option: any, i: any) => {
        if (i == dataIndex) {
          option[inputId] = inputStateValue;
          option[inputId] != ""
            ? setSubmitClickFlag(false)
            : setSubmitClickFlag(true);
        }
        return option;
      }),
    });
    console.log(userData.references);
  };
  const setInputState = (inputStateValue: any, inputId: any) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
    console.log(inputStateValue);
  };
  const onChangeItem = (selectedItemValue: any) => {
    console.log(selectedItemValue);
    if (selectedItemValue.value != "") {
      if (
        selectedItemValue.id == "worked_in_public_sector" ||
        selectedItemValue.id == "worked_in_private_sector" ||
        selectedItemValue.id == "insurance_in_place"
      ) {
        selectedItemValue.value =
          selectedItemValue.value == "Yes" ? "true" : "false";
      }
    }
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };

  const addNewHandler = (
    addNewModalExistFlag: any,
    modalFlag: any,
    addNewModalPropsData: any
  ) => {
    setShowAddNewModalExist(addNewModalExistFlag);
    setShowAddNewModal(modalFlag);
    setAddNewModalProps({ ...addNewModalProps, ...addNewModalPropsData });
  };
  const onChangeMultiItem = (
    obj: any,
    inputId: any,
    routeFrom: any,
    objId: any
  ) => {
    if (routeFrom == "add_in_drop_down") {
      if (inputId == "industrySectorList_attribute") {
        setIndustrySectorList_attribute(
          industrySectorList_attribute.concat({
            id: objId,
            value: obj,
            label: obj,
          })
        );
      }
      if (inputId == "complementaryServiceArr_attribute") {
        setComplementaryServiceArr_attribute(
          complementaryServiceArr_attribute.concat({
            id: objId,
            value: obj,
            label: obj,
          })
        );
      }
      if (inputId == "sectorExperienceArr_attribute") {
        setSectorExperienceArr_attribute(
          sectorExperienceArr_attribute.concat({
            id: objId,
            value: obj,
            label: obj,
          })
        );
      }
      if (inputId == "disciplineArr_attribute") {
        setDisciplineArr_attribute(
          disciplineArr_attribute.concat({ id: objId, value: obj, label: obj })
        );
      }
      if (inputId == "atWhatLevelArr_attribute") {
        setAtWhatLevelArr_attribute(
          atWhatLevelArr_attribute.concat({ id: objId, value: obj, label: obj })
        );
      }
      if (inputId == "levelArr_attribute") {
        setLevelArr_attribute(
          levelArr_attribute.concat({ id: objId, value: obj, label: obj })
        );
      }

      setAddNewFlag(true);
    } else {
      if (inputId == "industrySectorList_attribute") {
        industrySectorList_attribute.length = 0;
        setIndustrySectorList_attribute(
          industrySectorList_attribute.concat(obj)
        );
      }
      if (inputId == "complementaryServiceArr_attribute") {
        complementaryServiceArr_attribute.length = 0;
        setComplementaryServiceArr_attribute(
          complementaryServiceArr_attribute.concat(obj)
        );
      }
      if (inputId == "sectorExperienceArr_attribute") {
        sectorExperienceArr_attribute.length = 0;
        setSectorExperienceArr_attribute(
          sectorExperienceArr_attribute.concat(obj)
        );
      }
      if (inputId == "disciplineArr_attribute") {
        disciplineArr_attribute.length = 0;
        setDisciplineArr_attribute(disciplineArr_attribute.concat(obj));
      }
      if (inputId == "atWhatLevelArr_attribute") {
        atWhatLevelArr_attribute.length = 0;
        setAtWhatLevelArr_attribute(atWhatLevelArr_attribute.concat(obj));
      }
      if (inputId == "levelArr_attribute") {
        levelArr_attribute.length = 0;
        setLevelArr_attribute(levelArr_attribute.concat(obj));
      }
    }
  };

  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };
  const viewLink = (index: any) => {
    console.log(userData.references);
    setLoading(true);
    AdminPartnerClient.ViewLink_get({
      partner_profile_id: global_data.partner_profile,
      email: userData.references[index].email,
    })
      .then((response: any) => {
        if (response.data && response.success) {
          viewDataArr.length = 0;
          setViewDataArr(viewDataArr.concat(response.data));
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const sendLink = (index: any) => {
    console.log(userData.references);
    setLoading(true);
    AdminPartnerClient.SendLink_get({
      partner_profile_id: global_data.partner_profile,
      email: userData.references[index].email,
      name: userData.references[index].name,
    })
      .then((response: any) => {
        if (userData.references[index].email == "") {
          dispatch(showSnackbar("error", [response.message]));
        } else {
          if (response.success) {
            dispatch(showSnackbar("success", [response.message]));
          } else {
            dispatch(showSnackbar("error", [response.message]));
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const onImageChange = (event: any, id: any) => {
    // console.log(id, event)
    var localArr = [];
    var pdata = {
      attributes: {
        document: event.target.files[0],
        // "created_at": new Date().toLocaleString(),
        file_name: event.target.files[0].name,
        id: passportArr.length + 1,
      },
    };
    localArr.push(pdata);
    // setDataArr(dataArr.concat(localArr))
    id == "resume" && setPassportArr(passportArr.concat(localArr));
  };

  return (
    <div ref={firstElementRef}>
      <Grid
        container
        direction='row'
        alignItems='center'
        style={{ padding: 30, marginBottom: 40 }}
      >
        {console.log(userData)}
        <Grid item xs={10}>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "1" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText == "1" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "1" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Business experience
              </Typography>
              <CustomInput
                id='business_experience'
                placeholder=''
                multiline={true}
                rows={4}
                parentcall={setInputState}
                onClick={() => setFocusText("1")}
                value={userData.business_experience}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "2" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText == "2" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "2" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                How do you keep up-to-date with business issues?
              </Typography>
              <CustomInput
                id='up_to_date_with_business_issues'
                placeholder=''
                multiline={true}
                rows={4}
                parentcall={setInputState}
                onClick={() => setFocusText("2")}
                value={userData.up_to_date_with_business_issues}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card variant='outlined' style={{ borderWidth: 0 }}>
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Date you started coaching
              </Typography>
              <DateComponent
                key={"011"}
                componentObject={{
                  componentType: "datePicker",
                  required: true,
                  label: "",
                  name: "coaching_started_date",
                  placeholder: "DD/MM/YYYY",
                  helperText: false,
                  indexKey: "0-0",
                  index: "coaching_started_date",
                  handleChange: setInputState,
                  value: userData.coaching_started_date,
                }}
              />
            </Card>
          </Grid>
          {/* <Grid item xs={12} style={{ marginBottom: 30 }}>
                        <Card variant="outlined" style={{ padding: "30px 10px", borderWidth: 0 }} >
                            <Typography variant="h2"  style={{ marginBottom: 5 }}>How long have you operated as a coach?</Typography>
                            <CustomInput id="How long have you operated as a coach" variant="outlined" placeholder="Numeric Input" parentcall={setInputState} />
                        </Card>
                    </Grid> */}
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            {/* <Card variant="outlined" style={{ borderWidth: 0 }} > */}
            <Typography variant='h2' style={{ marginBottom: 5 }}>
              In which industry sectors have you delivered coaching to?
            </Typography>
            {/* <CustomSelect id="industry_sector_list_id"
                                labelText="Select Industry"
                                displayEmpty variant="outlined" itemArr={industrySectorListArr}
                                parentcall={onChangeItem} defaultValue={userData.industry_sector_list_id} /> */}
            {console.log(industrySectorListArr)}

            <CustomSelectMulti
              id='industrySectorList_attribute'
              itemArr={industrySectorListArr}
              drop_down='IndustrySectorList'
              addNewHandler={addNewHandler}
              field_name='industry_sector'
              addNewFlag={true}
              setValueAdded={setValueAdded}
              parentcall={onChangeMultiItem}
              placeholder='Select industry'
              value={industrySectorList_attribute}
            />

            {/* </Card> */}
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card variant='outlined' style={{ borderWidth: 1 }}>
              <Grid
                container
                direction='row'
                alignItems='center'
                style={{ padding: "0px 0px 0px 30px", marginBottom: 0 }}
              >
                <Grid item xs={3}>
                  <Typography variant='h2' style={{ marginBottom: 5 }}>
                    Workload distribution
                  </Typography>
                </Grid>
                <Grid item xs={9} style={{ border: "1px solid #ddd" }}>
                  <Grid
                    container
                    direction='row'
                    alignItems='center'
                    style={{
                      padding: "15px 30px",
                      marginBottom: 0,
                      border: "1px solid #ddd",
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        Executive coaching
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <CustomInput
                        id='executive_coaching'
                        placeholder=''
                        parentcall={setInputState}
                        onClick={() => setFocusText("8")}
                        value={
                          userData.executive_coaching == null
                            ? ""
                            : userData.executive_coaching
                        }
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        %
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction='row'
                    alignItems='center'
                    style={{
                      padding: "15px 30px",
                      marginBottom: 0,
                      border: "1px solid #ddd",
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        Other forms of coaching
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <CustomInput
                        id='other_forms_of_coaching'
                        placeholder=''
                        parentcall={setInputState}
                        onClick={() => setFocusText("5")}
                        value={
                          userData.other_forms_of_coaching == null
                            ? ""
                            : userData.other_forms_of_coaching
                        }
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        %
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction='row'
                    alignItems='center'
                    style={{
                      padding: "15px 30px",
                      marginBottom: 0,
                      border: "1px solid #ddd",
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        Team coaching
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <CustomInput
                        id='team_coaching'
                        placeholder=''
                        parentcall={setInputState}
                        onClick={() => setFocusText("7")}
                        value={
                          userData.team_coaching == null
                            ? ""
                            : userData.team_coaching
                        }
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        %
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction='row'
                    alignItems='center'
                    style={{
                      padding: "15px 30px",
                      marginBottom: 0,
                      border: "1px solid #ddd",
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        Training
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <CustomInput
                        id='training'
                        placeholder=''
                        parentcall={setInputState}
                        onClick={() => setFocusText("10")}
                        value={
                          userData.training == null ? "" : userData.training
                        }
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        %
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction='row'
                    alignItems='center'
                    style={{
                      padding: "15px 30px",
                      marginBottom: 0,
                      border: "1px solid #ddd",
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        Group facilitation
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <CustomInput
                        id='group_facilitation'
                        placeholder=''
                        parentcall={setInputState}
                        onClick={() => setFocusText("3")}
                        value={
                          userData.group_facilitation == null
                            ? ""
                            : userData.group_facilitation
                        }
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        %
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction='row'
                    alignItems='center'
                    style={{
                      padding: "15px 30px",
                      marginBottom: 0,
                      border: "1px solid #ddd",
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        Other
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <CustomInput
                        id='other'
                        placeholder=''
                        parentcall={setInputState}
                        onClick={() => setFocusText("4")}
                        value={userData.other == null ? "" : userData.other}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        %
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          <Grid item xs={12} style={{ marginBottom: 30 }}>
            {/* <Card variant="outlined" style={{ borderWidth: 0 }} > */}
            <Typography variant='h2' style={{ marginBottom: 5 }}>
              What complimentary services do you offer?
            </Typography>
            {/* <CustomSelect id="complementary_service_id" labelText="Select complimentary services" displayEmpty variant="outlined" itemArr={complementaryServiceArr} parentcall={onChangeItem} defaultValue={userData.complementary_service_id} /> */}
            <CustomSelectMulti
              id='complementaryServiceArr_attribute'
              itemArr={complementaryServiceArr}
              drop_down='ComplementaryService'
              addNewHandler={addNewHandler}
              field_name='complementary_service'
              addNewFlag={true}
              setValueAdded={setValueAdded}
              parentcall={onChangeMultiItem}
              placeholder='Select complimentary services'
              // helperText={(submitClickFlag && (complementaryServiceArr_attribute.length == 0)) ? "* Please select partner type" : ""}
              // error={(submitClickFlag && complementaryServiceArr_attribute.length == 0) ? true : false}
              value={complementaryServiceArr_attribute}
            />
            {/* </Card> */}
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card variant='outlined' style={{ borderWidth: 0 }}>
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Coach training hours
              </Typography>
              <CustomSelect
                id='coach_training_hr_id'
                labelText='Select coach training hours'
                displayEmpty
                variant='outlined'
                itemArr={coachTrainingHrArr}
                parentcall={onChangeItem}
                defaultValue={userData.coach_training_hr_id}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card variant='outlined' style={{ borderWidth: 0 }}>
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Coaching hours
              </Typography>
              <CustomSelect
                id='coaching_hr_id'
                labelText='Select coaching hours'
                displayEmpty
                variant='outlined'
                itemArr={coachHrArr}
                parentcall={onChangeItem}
                defaultValue={userData.coaching_hr_id}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "11" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText == "11" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "11" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                How do you evaluate and measure the success of your coaching
                assignments?
              </Typography>
              <CustomInput
                id='evaluate_and_measure_coaching_assignments'
                placeholder=''
                multiline={true}
                rows={4}
                parentcall={setInputState}
                onClick={() => setFocusText("11")}
                value={userData.evaluate_and_measure_coaching_assignments}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "12" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText == "12" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "12" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Preferences - under what conditions do you get your best
                results?
              </Typography>
              <CustomInput
                id='preferences'
                placeholder=''
                multiline={true}
                rows={4}
                parentcall={setInputState}
                onClick={() => setFocusText("12")}
                value={userData.preferences}
              />
            </Card>
          </Grid>

          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "13" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText == "13" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "13" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                What are the criteria for you to have a good Associate/ Partner
                relationship with a managed service provider?
              </Typography>
              <CustomInput
                id='criteria_for_good_relationship_with_service_provider'
                multiline={true}
                rows={4}
                placeholder=''
                parentcall={setInputState}
                onClick={() => setFocusText("13")}
                value={
                  userData.criteria_for_good_relationship_with_service_provider
                }
              />
            </Card>
          </Grid>

          {/* <Grid item xs={12} style={{ marginBottom: 30 }}>
                        <Card variant={focusText == '7' ? "elevation" : "outlined"} style={{ padding: "30px 10px", border: (focusText == '9') ? '0px solid #3B86FF' : '', borderLeftWidth: (focusText == '9') ? '5px' : "1px" }}>
                            <Typography variant="h2"  style={{ marginBottom: 5 }}>What did you have responsibility for?</Typography>
                            <CustomInput id="What did you have responsibility for" placeholder="" parentcall={setInputState} onClick={() => setFocusText('9')} value={userData.up_to_date_with_business_issues} />
                        </Card>
                    </Grid> */}

          {/* <Grid item xs={12} style={{ marginBottom: 30 }}>
                        <Card variant="outlined" style={{ padding: "30px 10px", borderWidth: 0, }} >
                            <Typography variant="h2"  style={{ marginBottom: 5 }}>(Please explain your role within the organization)</Typography>
                            <CustomInput id="Please explain your role within the organization" placeholder="" parentcall={setInputState} />
                        </Card>
                    </Grid> */}
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            {/* <Card variant="outlined" style={{ borderWidth: 0 }} > */}
            <Typography variant='h2' style={{ marginBottom: 5 }}>
              What industry sectors did you work in? e.g. Financial Services,
              IT, Retail
            </Typography>

            <CustomSelectMulti
              id='sectorExperienceArr_attribute'
              itemArr={sectorExperienceArr}
              drop_down='SectorExperience'
              addNewHandler={addNewHandler}
              field_name='sector_experience'
              addNewFlag={true}
              setValueAdded={setValueAdded}
              parentcall={onChangeMultiItem}
              placeholder='Select sector experience'
              // helperText={(submitClickFlag && (sectorExperienceArr_attribute.length == 0)) ? "* Please select partner type" : ""}
              // error={(submitClickFlag && sectorExperienceArr_attribute.length == 0) ? true : false}
              value={sectorExperienceArr_attribute}
            />

            {/* <CustomSelect id="sector_experience_id"
                                labelText="Select Industry"
                                displayEmpty variant="outlined" itemArr={sectorExperienceArr}
                                parentcall={onChangeItem} defaultValue={userData.sector_experience_id} /> */}
            {/* </Card> */}
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            {/* <Card variant="outlined" style={{ borderWidth: 0 }} > */}
            <Typography variant='h2' style={{ marginBottom: 5 }}>
              What disciplines did you work in?
            </Typography>
            {/* <CustomSelect id="discipline_id"
                                labelText="Select Discipline"
                                displayEmpty variant="outlined" itemArr={disciplineArr}
                                parentcall={onChangeItem} defaultValue={userData.discipline_id} /> */}

            <CustomSelectMulti
              id='disciplineArr_attribute'
              itemArr={disciplineArr}
              drop_down='Discipline'
              addNewHandler={addNewHandler}
              field_name='discipline'
              addNewFlag={true}
              setValueAdded={setValueAdded}
              parentcall={onChangeMultiItem}
              placeholder='Select discipline'
              // helperText={(submitClickFlag && (disciplineArr_attribute.length == 0)) ? "* Please select partner type" : ""}
              // error={(submitClickFlag && disciplineArr_attribute.length == 0) ? true : false}
              value={disciplineArr_attribute}
            />

            {/* </Card> */}
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            {/* <Card variant="outlined" style={{ borderWidth: 0 }} > */}
            <Typography variant='h2' style={{ marginBottom: 5 }}>
              At what level did you work at?
            </Typography>
            {/* <CustomSelect id="at_what_level_id" labelText="Select level" displayEmpty variant="outlined" itemArr={atWhatLevelArr} parentcall={onChangeItem} defaultValue={userData.at_what_level_id} /> */}
            <CustomSelectMulti
              id='atWhatLevelArr_attribute'
              itemArr={atWhatLevelArr}
              drop_down='AtWhatLevel'
              addNewHandler={addNewHandler}
              field_name='at_what_level'
              addNewFlag={true}
              setValueAdded={setValueAdded}
              parentcall={onChangeMultiItem}
              placeholder='Select level'
              // helperText={(submitClickFlag && (atWhatLevelArr_attribute.length == 0)) ? "* Please select partner type" : ""}
              // error={(submitClickFlag && atWhatLevelArr_attribute.length == 0) ? true : false}
              value={atWhatLevelArr_attribute}
            />
            {/* </Card> */}
          </Grid>
          {role === "partner" && (
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <Card
                variant={focusText === "6" ? "elevation" : "outlined"}
                style={{
                  padding: "30px 10px",
                  border: focusText === "6" ? "0px solid #3B86FF" : "",
                  borderLeftWidth: focusText === "6" ? "5px" : "1px",
                }}
              >
                <Typography variant='h2' style={{ marginBottom: 5 }}>
                  In which industry sectors have you coached in?
                </Typography>
                <CustomInput
                  id='industry_sector_coached_in'
                  placeholder=''
                  parentcall={setInputState}
                  onClick={() => setFocusText("6")}
                  value={userData.industry_sector_coached_in}
                />
              </Card>
            </Grid>
          )}
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "14" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText == "14" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "14" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                What was your last job title?
              </Typography>
              <CustomInput
                id='last_job_title'
                placeholder=''
                parentcall={setInputState}
                onClick={() => setFocusText("14")}
                value={userData.last_job_title}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText === "15" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText === "15" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText === "15" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Most senior role held
              </Typography>
              <CustomInput
                id='most_senior_role_held'
                placeholder=''
                parentcall={setInputState}
                onClick={() => setFocusText("15")}
                value={userData.most_senior_role_held}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText === "16" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText === "16" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText === "16" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                What was your role experience?
              </Typography>
              <CustomInput
                id='role_experience'
                placeholder=''
                multiline={true}
                rows={4}
                parentcall={setInputState}
                onClick={() => setFocusText("16")}
                value={userData.role_experience}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card variant='outlined' style={{ padding: 0, borderWidth: 0 }}>
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Have you worked in the public sector?
              </Typography>
              <CustomSelect
                labelText='Have you worked in the public sector?'
                id='worked_in_public_sector'
                displayEmpty
                variant='outlined'
                itemArr={["Yes", "No"]}
                defaultValue={
                  userData.worked_in_public_sector != ""
                    ? userData.worked_in_public_sector == "true"
                      ? "Yes"
                      : "No"
                    : "0"
                }
                parentcall={onChangeItem}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card variant='outlined' style={{ padding: 0, borderWidth: 0 }}>
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Have you worked in the private sector?
              </Typography>
              <CustomSelect
                labelText='Have you worked in the private sector?'
                id='worked_in_private_sector'
                displayEmpty
                variant='outlined'
                itemArr={["Yes", "No"]}
                defaultValue={
                  userData.worked_in_private_sector != ""
                    ? userData.worked_in_private_sector == "true"
                      ? "Yes"
                      : "No"
                    : "0"
                }
                parentcall={onChangeItem}
              />
            </Card>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            {/* <Card variant="outlined" style={{ padding: 0, borderWidth: 0, }} > */}
            <Typography variant='h2' style={{ marginBottom: 5 }}>
              What levels do you coach at?
            </Typography>
            {/* <CustomSelect id="level_id" labelText="Select Client levels" displayEmpty variant="outlined" itemArr={levelArr} parentcall={onChangeItem} defaultValue={userData.level_id} /> */}
            <CustomSelectMulti
              id='levelArr_attribute'
              itemArr={levelArr}
              drop_down='Level'
              addNewHandler={addNewHandler}
              field_name='level'
              addNewFlag={true}
              setValueAdded={setValueAdded}
              parentcall={onChangeMultiItem}
              placeholder='Select level'
              // helperText={(submitClickFlag && (levelArr_attribute.length == 0)) ? "* Please select partner type" : ""}
              // error={(submitClickFlag && levelArr_attribute.length == 0) ? true : false}
              value={levelArr_attribute}
            />
            {/* </Card> */}
          </Grid>
          {/* <Grid item xs={12} style={{ marginBottom: 0 }}>

                        <Grid container direction="row" alignItems="flex-end" justify="flex-start" style={{ marginBottom: 0 }}>
                            <Grid item xs={8}>
                                <Card variant="outlined" style={{ padding: 0, borderWidth: 0, }} >
                                    <Typography variant="h2"  style={{ marginBottom: 5 }}>Insurence in place yes or no with upload</Typography>
                                    <CustomSelect
                                        labelText="Select Insurence in place yes or no with upload "
                                        id="Insurence in place yes or no with upload" displayEmpty variant="outlined" itemArr={['Yes', 'No']}
                                        // defaultValue={userData.bame != "" ? userData.bame == "true" ? "Yes" : "No" : "0"}
                                        parentcall={onChangeItem} />
                                </Card>
                            </Grid>
                            <Grid item xs={4} style={{ textAlign: "center" }}>
                                <label htmlFor="upload-photo">
                                    <input onChange={(e) => { onImageChange(e) }} accept="application/pdf, application/vnd.ms-excel,image/gif, image/jpeg" style={{ display: 'none' }} id="upload-photo" name="upload-photo" type="file" />
                                    <Button  disableElevation  color="secondary" variant="contained" component="span" style={{ fontSize: 12 }}><CloudUpload style={{ marginRight: 10 }} />Upload</Button>
                                </label>
                            </Grid>
                        </Grid>


                    </Grid>
                    <Grid container direction="row" alignItems="center" style={{ marginBlock: 20 }}>
                        <Grid item xs={8} >
                            <Grid container direction="row" alignItems="flex-start" spacing={2}>
                                {dataArr.map((option: any) => <Grid item xs={4} >
                                    <div style={{ width: "100%", backgroundColor: "#ddd", margin: 10, borderRadius: 5 }}>
                                        <div style={{ position: "relative", padding: 10, width: "100%", }}>
                                            <Cancel style={{ marginRight: 10, position: "absolute", top: -9, right: 0, fontSize: 16 }} />
                                            <Typography noWrap variant="h2" style={{ color: "#3B86FF", fontSize: 12, width: "85%" }}>{option.attributes.created_at.split("T")[0]}</Typography>
                                            <Typography noWrap variant="h2" title={option.attributes.file_name} style={{ fontSize: 12, width: "85%" }}>{option.attributes.file_name}</Typography>
                                        </div>
                                    </div>
                                </Grid>)}

                            </Grid>

                        </Grid>
                    </Grid> */}
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "20" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px 0",
                border: focusText == "20" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "20" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Summary bio
              </Typography>
              <CustomInput
                id='thumbnail_bio'
                placeholder=''
                multiline={true}
                rows={4}
                parentcall={setInputState}
                onClick={() => setFocusText("20")}
                value={userData.thumbnail_bio}
              />
              <Typography
                variant='h6'
                style={{ marginBottom: 5, fontSize: 12, paddingBottom: 10 }}
              >
                Note: Summary bios need to be around 150 words providing an
                overview of your corporate background and relevant coaching
                background/experience.
              </Typography>
            </Card>
          </Grid>

          {role === "admin" && (
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <Grid container direction='row' alignItems='flex-end' spacing={1}>
                <Grid item xs={10}>
                  <Card
                    variant='outlined'
                    style={{ padding: 0, borderWidth: 0 }}
                  >
                    <Typography variant='h2' style={{ marginBottom: 5 }}>
                      Insurance in place Yes/No
                    </Typography>
                    <CustomSelect
                      labelText='Insurance in place Yes/No?'
                      id='insurance_in_place'
                      displayEmpty
                      variant='outlined'
                      itemArr={["Yes", "No"]}
                      defaultValue={
                        userData.insurance_in_place != ""
                          ? userData.insurance_in_place == "true"
                            ? "Yes"
                            : "No"
                          : "0"
                      }
                      parentcall={onChangeItem}
                    />
                  </Card>
                </Grid>
                {userData.insurance_in_place == "true" && (
                  <Grid item xs={2}>
                    <label htmlFor='upload-photo-resume'>
                      <input
                        onChange={(e) => {
                          onImageChange(e, "resume");
                        }}
                        accept='application/pdf, application/vnd.ms-excel,image/gif, image/jpeg'
                        style={{ display: "none" }}
                        id='upload-photo-resume'
                        name='upload-photo'
                        type='file'
                      />
                      <Button
                        disableElevation
                        color='secondary'
                        variant='contained'
                        component='span'
                        style={{ fontSize: 12 }}
                      >
                        <CloudUpload style={{ marginRight: 10 }} />
                        Upload
                      </Button>
                    </label>
                  </Grid>
                )}
              </Grid>
              <Grid container direction='row'>
                <Grid item xs={12}>
                  {passportArr.length > 0 &&
                    StepperService.uploadImageCard(
                      passportArr,
                      setPassportArr,
                      "/partner_profile/delete_insurance_photo/",
                      null,
                      dispatch
                    )}
                </Grid>
              </Grid>
            </Grid>
          )}

          {role === "admin" && (
            <Grid item xs={12}>
              <Card
                variant='outlined'
                style={{ padding: "0px 10px 30px", borderWidth: 0 }}
              >
                <Grid container direction='row' alignItems='center'>
                  <Grid item xs={12}>
                    <Typography variant='h2' style={{ marginBottom: 5 }}>
                      Reference contact details
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: 30 }}>
                    {console.log(`userData.references`, userData.references)}
                    <Grid container direction='row' alignItems='center'>
                      <Grid item xs={2}></Grid>

                      <Grid item xs={10}>
                        <Grid container direction='row' alignItems='center'>
                          <Grid item xs={3} style={{ padding: 5 }}>
                            <Typography
                              variant='h2'
                              style={{ marginBottom: 5, textAlign: "center" }}
                            >
                              Full name
                            </Typography>
                          </Grid>
                          <Grid item xs={3} style={{ padding: 5 }}>
                            <Typography
                              variant='h2'
                              style={{ marginBottom: 5, textAlign: "center" }}
                            >
                              Email
                            </Typography>
                          </Grid>
                          <Grid item xs={4} style={{ padding: 5 }}>
                            <Typography
                              variant='h2'
                              style={{ marginBottom: 5, textAlign: "center" }}
                            >
                              Phone
                            </Typography>
                          </Grid>
                          <Grid item xs={2} style={{ padding: 5 }}></Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    {userData.references.map((option: any, i: any) => (
                      <Grid container direction='row' alignItems='center'>
                        <Grid item xs={2}>
                          <Typography variant='h2' style={{ marginBottom: 5 }}>
                            Reference {i + 1} {role === "admin" ? "" : ""}
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Grid container direction='row' alignItems='center'>
                            <Grid item xs={3} style={{ padding: 5 }}>
                              <CustomInput
                                id='name'
                                variant='outlined'
                                dataIndex={i}
                                // error={(role == "admin" && submitClickFlag && option.name == "") ? true : false}
                                placeholder='Full name'
                                parentcall={setRefInputState}
                                value={option.name}
                              />
                            </Grid>
                            <Grid item xs={3} style={{ padding: 5 }}>
                              <CustomInput
                                id='email'
                                variant='outlined'
                                dataIndex={i}
                                placeholder='Email'
                                // error={(role == "admin" && submitClickFlag && option.email == "" && !regex.test(option['email'])) ? true : false}
                                // helperText={(submitClickFlag) && !regex.test(option['email']) ? "* Invalid email" : ""}

                                parentcall={setRefInputState}
                                value={option.email}
                              />
                            </Grid>
                            <Grid item xs={4} style={{ padding: 5 }}>
                              <PhoneInput
                                // containerClass={(role == "admin" && submitClickFlag && option.phone == "") ? "error" : ""}
                                country={"gb"}
                                value={"" + option.phone}
                                onChange={(value: any) => {
                                  setRefInputStateOnChange(value, "phone", i);
                                }}
                                // defaultErrorMessage="*  Please enter Mobile number"
                              />
                              {/* {
                                                            ((option.phone == "" || option.phone == "0") && submitClickFlag) &&
                                                            <InputLabel style={{ color: "#f44336", fontSize: "0.75rem", marginTop: 3, marginLeft: 0 }}>* Please enter mobile</InputLabel>
                                                        } */}

                              {/* <CustomInput id="phone" variant="outlined" dataIndex={i} inputProps={{ maxLength: 10 }} placeholder="Phone"
                                                            error={(role == "admin" && submitClickFlag && option.phone == "") ? true : false} parentcall={setRefInputState} value={option.phone} /> */}
                            </Grid>
                            <Grid item xs={2} style={{ padding: 5 }}>
                              <Button
                                disableElevation
                                onClick={() => {
                                  sendLink(i);
                                }}
                                color='secondary'
                                style={{ fontSize: 12 }}
                              >
                                Send Link
                              </Button>
                              <Button
                                disableElevation
                                onClick={() => {
                                  viewLink(i);
                                  setViewDataFlag(true);
                                }}
                                color='secondary'
                                style={{ fontSize: 12 }}
                              >
                                View Data
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                    {/* <Grid container direction="row" alignItems="center" >
                                        <Grid item xs={4} style={{ padding: 5 }}>
                                            {
                                                submitClickFlag && <div style={{ color: "#f44336", fontSize: 12 }}>* Please enter required fields</div>
                                            }
                                        </Grid>
                                    </Grid> */}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          )}
          {role === "admin" && (
            <Grid item xs={12} style={{ marginBottom: 30 }}>
              <Card
                variant={focusText == "21" ? "elevation" : "outlined"}
                style={{
                  padding: "30px 10px",
                  border: focusText == "21" ? "0px solid #3B86FF" : "",
                  borderLeftWidth: focusText == "21" ? "5px" : "1px",
                }}
              >
                <Typography variant='h2' style={{ marginBottom: 5 }}>
                  Reference other
                </Typography>
                <CustomInput
                  id='reference_other'
                  placeholder=''
                  multiline={true}
                  rows={4}
                  // helperText={(role == 'admin' && submitClickFlag && userData.reference_other == "") ? "Please select reference other" : ""}
                  // error={(role == 'admin' && submitClickFlag && userData.reference_other == "") ? true : false}
                  parentcall={setInputState}
                  onClick={() => setFocusText("21")}
                  value={userData.reference_other}
                />
              </Card>
            </Grid>
          )}
          <Grid item xs={12} style={{ marginBottom: 30 }}>
            <Card
              variant={focusText == "22" ? "elevation" : "outlined"}
              style={{
                padding: "30px 10px",
                border: focusText == "22" ? "0px solid #3B86FF" : "",
                borderLeftWidth: focusText == "22" ? "5px" : "1px",
              }}
            >
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                Additional information
              </Typography>
              <CustomInput
                id='additional_information'
                placeholder=''
                multiline={true}
                rows={4}
                parentcall={setInputState}
                onClick={() => setFocusText("22")}
                value={userData.additional_information}
              />
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <Header
        saveBtnTitle={"Save & Proceed"}
        isBack={true}
        parentcall={onSubmit}
        parentBackCall={onBack}
      />
      {showAddNewModalExist && showAddNewModal && (
        <AddToListModal
          type='partner_profiles'
          postData={{ ...addNewModalProps }}
        />
      )}
      {viewDataFlag && (
        <Dialog
          fullWidth
          open={true}
          onClose={() => {
            setViewDataFlag(false);
          }}
          aria-labelledby='form-dialog-title'
        >
          <DialogTitle id='form-dialog-title'>View Data</DialogTitle>
          <DialogContent>
            {viewDataArr.length > 0 ? (
              viewDataArr.map((option: any) => {
                return (
                  <Grid
                    container
                    direction='row'
                    alignItems='flex-start'
                    spacing={1}
                  >
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        {option.attributes.question_id}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant='h2' style={{ marginBottom: 5 }}>
                        {option.attributes.answer}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })
            ) : (
              <Typography variant='h2' style={{ marginBottom: 5 }}>
                No data found
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              disableElevation
              onClick={() => {
                setViewDataFlag(false);
              }}
              color='primary'
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {loading && <CircularIndeterminate />}
    </div>
  );
}

export default Questionnaire;
